import React, {Component} from 'react';
//import * as routes from '../../constants/routes'
import DefaultPage from '../../Container/Layout/DefaultPage'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { doAddEvent, fetchTasks } from '../../firebase/db'
//import AddEventInfo from './AddEventInfo'
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {compose} from 'recompose'
import moment from 'moment'
import Checkbox from '@material-ui/core/Checkbox'
import Input from '@material-ui/core/Input';
//import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

const styles = theme => ({
  paper: {
    display: 'inline-block',
    padding: '1em',
    marginBottom: '1em',
    marginRight: '1em',
    maxWidth: '320px'
  },
  textField: {
    marginBottom: theme.spacing.unit *2,
   //marginRight: theme.spacing.unit,
    
  },
  taskSelect : {
    overflow: 'hidden',
    maxWidth: '300px'
  },
 
});

const byPropKey = (propertyName, value) => () => {
return ({
    [propertyName]: value,
  });

}

const preDate = moment().add(2, 'days').format('YYYY-MM-DD');

class AddEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTask: '',
      selectedTaskId: '',
      info: '',
      date: preDate,
      timeRange: '',
      pkwChecked: '',
      onTime: false,
      onTimeChecked: false,
      time:'',
    }
    this.dateInputRef = React.createRef()
  }

  handleFormChange = (propKey, value) => {
    if(propKey==='timeRange') {
      switch (value) {
        case '1week' : {
          
          this.setState({
            timeRange: '2weeks',
            date: moment().add(7, 'days').format('YYYY-MM-DD'),
            onTime: false,
            time: 'nv',
            onTimeChecked: false,
          })
          break
        }
        case '2weeks' : {
          this.setState({
            timeRange: '2weeks',
            date: moment().add(14, 'days').format('YYYY-MM-DD'),
            onTime: false,
            time: 'nv',
            onTimeChecked: false,
          })
          break
        }
        case 'onDate' : {
          this.setState({
              timeRange: 'onDate',
              date: moment().add(2, 'days').format('YYYY-MM-DD'),
              onTime: true,
            })
          break
        } 
        default : this.setState({
            timeRange: 'notSet',
            date: moment().add(7, 'days').format('YYYY-MM-DD')
          })

      }
      
    }
    if(propKey==='pkwChecked')
    // eslint-disable-next-line
    value===true ? null : value=false
    if(propKey==='selectedTaskId') this.setState({selectedTask: this.props.tasks[value].hilfen})
    return this.setState(byPropKey(propKey, value))
  }
  doResetForm = () =>{
    this.setState({
                    date: '',
                    info: '',
                    task: '',
                    timeRange: '',
                    selectedTask: '',
                    pkwChecked: false,
                    onTime: false,
                    onTimeChecked: false,
                    time: ''
                    })
  }
  
 onSubmit = (event) => {
  event.preventDefault(event)
    const {date, selectedTask, selectedTaskId, info, timeRange, pkwChecked, time, onTimeChecked} = this.state

    const isBigger2Days = date >= moment().add(2, 'days').format('YYYY-MM-DD')
    if(!isBigger2Days) {
      alert('Das Datum des Hilfebedarfs muss mindestends zwei Tage in der Zugkunft liegen')
      return this.dateInputRef.current.focus()
    }
  
    const checkTime = () => {
      if(onTimeChecked===false){
        return 'Nach Vereinbarung'
      } else {
        return time
      }
    }
    const { history } = this.props
    const { ort, id } = this.props.userProfile
    const author = 'user'
    doAddEvent(timeRange, date, selectedTask, ort, info, id, pkwChecked, author, checkTime(), selectedTaskId)
    history.push('EVENTS')
    //const uid = this.props.profile.userId
    this.doResetForm()
    this.props.onClickAddEvent(null)
 
  }

 
 componentDidMount () {
   //this.setState('userID', this.props.authUser.uid)'
  // this.props.doToggleView('EVENTS')
  
  const { onFetchTasks } = this.props
    fetchTasks.on('value', function(snapshot) {
      onFetchTasks(snapshot.val());
    });
    
  }

  render() {
    const {
        date,
        selectedTaskId,
        preTime,
        info,
        timeRange,
        onTimeChecked,
        time
      } = this.state;
      //form ist invaild if task datea or time (checked) is empty
    const isInvalid = selectedTaskId === '' || date === '' || (onTimeChecked===true && time==='');
   
   const {tasks, classes} = this.props
    return (
      
      <DefaultPage headline={{headlineText: 'Hilfebedarf erstellen'}}>
        <Paper className={classes.paper}>
        
          <form onSubmit={this.onSubmit}>
            <FormControl className={classes.formControl}>
              
            <FormLabel component="legend">In welchen Zeitraum soll die Hilfe erfolgen?</FormLabel>
          <RadioGroup
            aria-label="Zeitraum"
            name="timeRange"
            className={classes.group}
            value={timeRange}
            
            onChange={event => this.handleFormChange('timeRange', event.target.value)}
          >
            <FormControlLabel value="1week" control={<Radio />} label="Innerhalb 1 Woche" />
            <FormControlLabel value="2weeks" control={<Radio />} label="Innerhalb von 2 Wochen" />
            <FormControlLabel value="onDate" control={<Radio />} label="An einem bestimmten Datum" />
          </RadioGroup>
               

          {timeRange==='onDate'
            ? <TextField
                inputRef={this.dateInputRef}
                onChange={event => this.handleFormChange('date', event.target.value)}
                id="date"
                label="Datum der Hilfeleistung"
                type="date"
                defaultValue={preDate}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            : null
          }
          {this.state.onTime===true
            ?<FormControlLabel
                  control={
                    <Checkbox
                      onChange={event => this.handleFormChange('onTimeChecked', event.target.checked)}
                      checked={this.state.onTimeChecked}
                    />
                  }
                
                  label={this.state.onTimeChecked
                    ? <span style={{color: '#f50057'}}><strong>Uhrzeit erforderlich!</strong></span>
                    : <span>Zu einer bestimmten Uhrzeit?</span>}
                />
                :null


          }
          {onTimeChecked===true
            ? <TextField
                onChange={event => this.handleFormChange('time', event.target.value)}
                value={this.state.time}
                id="time"
                label="Uhrzeit der Hilfeleistung"
                type="time"
                defaultValue={preTime}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            : null
          }
                <FormHelperText>Für was benötigen Sie Hilfe?</FormHelperText>
                <Select
                  onChange={event => this.handleFormChange('selectedTaskId', event.target.value)}
                  value={selectedTaskId}
                  input={<Input name="task" id="task-label-placeholder" />}
                  displayEmpty
                  name="tasks"
                  className={classes.taskSelect}
                >
                  <MenuItem value="">
                    <em>Tätigkeit wählen</em>
                  </MenuItem >
                  {tasks 
                      ? tasks.map((taskItem, index) => 
                          <MenuItem style={{maxWidth: '350px', overlflow: 'scroll'}} name='task' key={index} value={taskItem.id}>
                            {taskItem.hilfen}
                          </MenuItem>
                        ) 
                      : null
                  }
              
                </Select>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={event => this.handleFormChange('pkwChecked', event.target.checked)}
                      checked={this.state.pkwChecked}
                    />
                  }
                
                  label={this.state.pkwChecked
                    ? <span style={{color: '#f50057'}}><strong>Ein Pkw wird benötigt.</strong></span>
                    : <span>Ist ein PKW erforderlich?</span>}
                />
            
              <TextField
                id="multiline-static"
                label="Zusatzinformationen"
                multiline
                rows="5"
                value={info}
                placeholder="Hier können Sie beliebige Zusatzinformationen eingeben"
                className={classes.textField}
                onChange={event => this.handleFormChange('info', event.target.value)}
                margin="normal"
              />
              
              <Button 
                type='submit' 
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={isInvalid}
              >
                Speichern
              </Button>
            </FormControl>
          </form>
          </Paper>
      </DefaultPage>
    )
  }
}

const mapStateToProps = (state) => ({
  userProfile: state.userState.profile,
  tasks: state.tasksState.tasks
});


const mapDispatchToProps = (dispatch) => ({
    onFetchTasks: (tasks) => dispatch({ type:'FETCH_TASKS', tasks}),
    onClickAddEvent: (value) => dispatch({ type: 'TOGGLE_ADDEVENT', value })
    
  });

//const authCondition = (authUser) => !!authUser;

AddEvent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps), 
  withStyles(styles))(AddEvent);


// WEBPACK FOOTER //
// ./src/Components/Events/AddEvent.js